import { ApiError } from './api-error';

// Sends a file to a signed storage URL (S3, R2, Spaces, GCS…). Storage is another origin and must
// not receive our cookies or API headers, so this skips the API client on purpose.
export async function putToStorage(
  upload: { url: string; method: 'PUT'; headers: Record<string, string> },
  file: Blob,
): Promise<void> {
  const res = await fetch(upload.url, {
    method: upload.method,
    headers: upload.headers,
    body: file,
    credentials: 'omit',
  }).catch(() => null);
  if (!res?.ok)
    throw new ApiError(
      res?.status ?? 0,
      'UPLOAD_FAILED',
      'The file could not be uploaded. Check your connection and try again.',
    );
}
